import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f30c3cfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile px-10 my-20" }
const _hoisted_2 = { class: "profile__wrapper text-center pa-40" }
const _hoisted_3 = { class: "mb-10" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-gradient text-center mb-20 d-inline-flex" }, "Накопленные баллы: 0", -1))
const _hoisted_5 = { class: "profile-actions" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "d-inline-flex mt-40" }, "Будь в курсе новостей!", -1))
const _hoisted_7 = {
  href: "https://t.me/kvik_films",
  target: "_blank"
}
const _hoisted_8 = {
  key: 0,
  class: "profile-votes mt-40"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "votes-title mb-10" }, "Твои идеи в голосовании", -1))
const _hoisted_10 = { class: "votes-vote mb-40" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "vote-title text-gradient text-center mb-20 d-inline-flex" }, "Мемасик", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" Посетить Японию "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gradient" }, "20%")
], -1))
const _hoisted_13 = { class: "votes-vote mb-40" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "vote-title text-gradient text-center mb-20 d-inline-flex" }, "Прекрасный сад", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text" }, [
  /*#__PURE__*/_createTextVNode(" Прыгнуть с парашютом "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gradient" }, "54%")
], -1))

import router from '@/router'
import BackLine from '@/components/Lines/BackLine.vue'
import CircleButton from '@/components/Buttons/CircleButton.vue'
import BaseButton from '@/components/Buttons/BaseButton.vue'
import IconBase from '@/components/Icons/IconBase.vue'

import { useAuthStore } from '@/stores/auth'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import SocLinks from '@/components/SocLinks.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileView',
  setup(__props) {


const authStore = useAuthStore()
const userStore = useUserStore()

const { user: userProfile } = storeToRefs(userStore)
const logout = () => {
  authStore.logout()
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BackLine, null, {
      default: _withCtx(() => [
        _createVNode(CircleButton, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1))),
          name: "chevron-left-gradient",
          bg: "empty",
          iconWidth: 21,
          iconHeight: 16,
          "view-box": "0 0 21 16"
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(userProfile)?.name || ''), 1),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(BaseButton, {
            class: "large rounded margin-auto mb-20 full-width",
            bg: "none",
            border: "default"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Изменить профиль")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: {name: 'profile-interface'} }, {
            default: _withCtx(() => [
              _createVNode(BaseButton, {
                class: "large rounded margin-auto mb-20 full-width",
                bg: "gradient",
                border: "gradient"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Изменить интерфейс")
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(BaseButton, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).go(-1))),
            class: "large rounded margin-auto mb-20 full-width",
            bg: "none",
            border: "default"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Назад")
            ]),
            _: 1
          }),
          _createVNode(BaseButton, {
            onClick: logout,
            class: "margin-auto mx-40",
            bg: "none",
            border: "none",
            color: "gradient"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Выйти")
            ]),
            _: 1
          })
        ]),
        _hoisted_6,
        _createElementVNode("a", _hoisted_7, [
          _createVNode(BaseButton, {
            class: "large rounded margin-auto my-20 full-width",
            bg: "none",
            border: "default"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Подписаться в Телеграм")
            ]),
            _: 1
          })
        ]),
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode(BaseButton, {
                  class: "large rounded full-width",
                  bg: "none",
                  border: "gradient"
                }, {
                  default: _withCtx(() => [
                    _hoisted_12,
                    _createVNode(IconBase, {
                      name: "upload",
                      "view-box": "0 0 16 18",
                      width: 16,
                      height: 18
                    })
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(BaseButton, {
                  class: "large rounded full-width",
                  bg: "none",
                  border: "gradient"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _createVNode(IconBase, {
                      name: "upload",
                      "view-box": "0 0 16 18",
                      width: 16,
                      height: 18
                    })
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(SocLinks)
    ])
  ], 64))
}
}

})